import { Component, Input } from "@angular/core"
import { Roster } from "../../../../models/roster.model"
import { Student } from "../../../../models/student.model"
import { GlobalStoreService } from "../../../../services/global-store.service"
import { ModalRef } from "../../../modal/modal-ref"

@Component({
    selector: "app-review-assignments-view",
    templateUrl: "./review-assignments-view.component.html",
    styleUrls: ["./review-assignments-view.component.less"],
})
export class ReviewAssignmentsViewComponent {
    @Input() public activityData: any
    @Input() public rosters: Roster[] = []
    @Input() public activeModal: ModalRef = null

    public googleClassImg: string = ""
    public similarResourceParams: string[] = []

    public constructor(private globalStoreService: GlobalStoreService) {
        this.googleClassImg = require("../../../../../assets/classroom-color-round.png").default
        this.similarResourceParams = this.globalStoreService.currentResource.getSimilarResourcesURL()
    }

    public toggleExpand(roster: Roster): void {
        if (roster) {
            if (roster.expanded) {
                roster.expanded = false
            } else {
                this.toggleOff()
                roster.expanded = true
            }
        }
    }

    public toggleOff() {
        this.rosters.map((r) => (r.expanded = false))
    }

    public hasClassStudents(roster: Roster) {
        return roster.students.find((student: Student) => {
            return student.selected
        })
    }
}
